import { getUserName } from '../../cred';

export const initialUserName = {
	userName: '',
};

export const fetchUserName = async () => {
	try {
		const { status, data } = await getUserName();

		if (status === 1) {
			return {
				userName: data,
			};
		}
	} catch (error) {
		console.log('getUserName', error);
	}
	return {};
};
